module.exports = __webpack_public_path__ + "static/media/qrcodeframe.86694ac1.svg";